/**
 * Alpine component behind crud::form.actions.save — the split "Opslaan en sluiten" /
 * "Opslaan" button. The picked action is remembered per browser and written into the
 * hidden `_save_action` input that RedirectAfterSave reads server-side.
 *
 * The preference lives in a COOKIE, not localStorage: the partial renders the
 * remembered label server-side, and localStorage only exists once JS has run —
 * the button would paint "Opslaan en sluiten" and visibly jump afterwards.
 */
const STORAGE_KEY = 'galaxy_save_action';

const isMac = /Mac|iPhone|iPad/i.test(navigator.userAgentData?.platform || navigator.platform || '');

const stored = () => document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${STORAGE_KEY}=`))
    ?.split('=')[1];

const register = () => window.Alpine.data('crudSaveSplit', () => ({

    open: false,
    action: 'close',
    shortcut: isMac ? '⌘S' : 'Ctrl+S',

    init() {
        const value = stored();

        if (value === 'close' || value === 'stay') {
            this.action = value;
        }
    },

    choose(action) {
        this.action = action;
        this.open = false;

        // A year, site-wide: the preference is the admin's, not the screen's.
        document.cookie = `${STORAGE_KEY}=${action}; path=/; max-age=31536000; samesite=lax`;

        this.run(action);
    },

    /** One-off submit with the given action, without changing the remembered default. */
    run(action) {
        this.$refs.action.value = action;

        this.$el.closest('form').requestSubmit();
    },
}));

if (window.Alpine) {
    register();
} else {
    document.addEventListener('alpine:init', register);
}
